import React, { useState, useEffect } from 'react';
import { Alert, Box, Chip, Typography } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import expirationService from '../../services/ExpirationService';

const ExpirationBanner = () => {
  const [expiringItems, setExpiringItems] = useState([]);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const checkExpirations = async () => {
      const data = await expirationService.getExpirationDates();
      const expiring = expirationService.checkForExpiringItems(data.expirations);
      
      if (expiring.length > 0) {
        setExpiringItems(expiring);
      }
    };
    
    checkExpirations();
    // Check every 24 hour
    const intervalId = setInterval(checkExpirations, 24 * 60 * 60 * 1000);
    
    return () => clearInterval(intervalId);
  }, []);

  // Don't show if nothing is expiring or banner was dismissed
  if (expiringItems.length === 0 || dismissed) {
    return null;
  }

  return (
    <Alert 
      severity="warning" 
      sx={{ 
        mb: 2, 
        mt: 1,
        display: 'flex',
        alignItems: 'center'
      }}
      icon={<SecurityIcon />}
      onClose={() => setDismissed(true)}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
        <Typography variant="body2" sx={{ mr: 1 }}>
          <strong>Attention:</strong> The following credentials are expiring soon:
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {expiringItems.map((item) => {
            const daysRemaining = expirationService.calculateDaysRemaining(item.expirationDate);
            return (
              <Chip
                key={item.name}
                label={`${item.name}: ${daysRemaining} days`}
                size="small"
                color={daysRemaining <= 3 ? "error" : "warning"}
                variant="outlined"
              />
            );
          })}
        </Box>
      </Box>
    </Alert>
  );
};

export default ExpirationBanner;